import { Show } from 'solid-js'

/**
 * Balance + top-up entry point.
 *
 * Read-only by design: this card never moves money, it only opens the top-up
 * flow. The single debit site lives in the API's checkout handler.
 */
export default function BalanceCard(props: {
  balanceCents: number
  onTopUp: () => void
}) {
  const euros = () => (props.balanceCents / 100).toFixed(2)
  const isLow = () => props.balanceCents < 500

  return (
    <section class="rounded-2xl bg-white/5 border border-white/10 p-5">
      <p class="text-sm text-white/60">Your balance</p>
      <p class="text-3xl font-bold tabular-nums mt-1">€{euros()}</p>

      <Show when={isLow()}>
        <p class="mt-2 text-xs text-amber-300">Low balance — top up to check in at venues.</p>
      </Show>

      <button
        type="button"
        onClick={() => props.onTopUp()}
        class="mt-4 w-full py-3 rounded-xl bg-emerald-500 text-emerald-950 font-semibold
               hover:bg-emerald-400 active:bg-emerald-300 transition-colors"
      >
        Top up
      </button>
    </section>
  )
}
